import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { ListMetadata } from '../../models/list-metadata.model';
import { Observable } from 'rxjs/Rx';
import { ActivatedRoute, Router } from '@angular/router';
import { CatalogGiftAssigned } from 'app/models/loyalty-catalog-gift-assigned.model';
import { publishReplay, refCount } from 'rxjs/operators';

@Injectable()
export class LoyaltyCatalogGiftAssignedService {

  baseUrl = HttpClientService.BASE_MS_LOYALTY;
  catalogId: number;
  storeId: number;
  headId: number;
  url: string;
  test: any;

  cachedField: Observable<CatalogGiftAssigned>;
  cachedFields: Observable<CatalogGiftAssigned>;

  constructor(
    private http: HttpClientService
  ) { }

    setStoreId(storeId: number){
      this.storeId = storeId;
    }

    setHeadId(headId: number){
      this.headId = headId;
    }

   /**
      * Tramite metodo GET, restituisce la lista dei Premi assegnati di una ricezione premi con il cliente, i punti e l'eventuale contributo
      * Prevede obbligatoriamente un offset ed un limite, permettendo la paginazione della lista.
    */
    list(
      offset = null,
      limit = null,
      search?: Array<{ key: string, value: string }>,
      globalSearch?: string,
      sort?: string,
      sort_dir?: number
    ): Observable<{ data: Array<CatalogGiftAssigned>, metadata: ListMetadata }> {
      const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
      return this.http.getPaged(this.baseUrl + `/reservation/giftAssignedList?store_id=${this.storeId}&reservation_head_id=${this.headId}` +
        (params.toString() ? '&' + params.toString().replace(/\+/gi, '%2B').replace(/'/gi, "''") : '' ));
    }

    /**
     * Metodo per ottenere tutti i record di una ricezione
     * @returns 
     */
    getRecordList(){
      return this.http.get(`${this.baseUrl}/reservation/giftAssignedList?store_id=${this.storeId}&reservation_head_id=${this.headId}`);
    }

    /**
     * Tramite GET carico i campi del dto di GiftItemAssigned in un Observable
     * @returns 
     */
     getCatlogGiftItemFields() {
      if (!this.cachedField) {
        this.cachedFields = this.http.get(`${this.baseUrl}/schema/ReservationAssignedListDto`).pipe(
          publishReplay(1), // this tells Rx to cache the latest emitted
          refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
        )
      }
      return this.cachedFields;
    }

    
}





// WEBPACK FOOTER //
// ./src/app/services/loyalty/loyalty-catalog-gift-assigned.service.ts